import Http from '../utilities/http';

export class ConsigneesApi {
  static search(query = {}) {
    return Http.get('/consignees', query);
  }

  static getById(id) {
    return Http.get(`/consignees/${id}`);
  }

  static update(id, data) {
    return Http.put(`/consignees/${id}`, data);
  }

  static add(data) {
    return Http.post('/consignees', data);
  }

  static batchAdd(data) {
    return Http.post('/consignees/batch', data);
  }

  static remove(id) {
    return Http.delete(`/consignees/${id}`);
  }
}
